export function libraryParameterDefinitionsListingURL(): string {
  return '/library-parameter-definitions/listing';
}
